import React, { useState } from "react";
import Modal from "../Modal/Modal";
import { useDispatch, useSelector } from "react-redux";
import { openModalAction } from "../../Redux/actions/modal";
import AboutHome from "./AboutHome";
import ServiceHome from "./ServiceHome";
import Testimonial from "./Testimonial";
import Reason from "./Reason";
import { RotatingLines } from "react-loader-spinner";

const Home = () => {
  const dispatch = useDispatch();
  const { modal } = useSelector((state) => state);
  const { isModalOpen } = modal;
  const [formVisible, setFormVisible] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formErrors, setFormErrors] = useState({});

  const [formData, setFormData] = useState({
    fullName: "",
    phoneNumber: "",
    contactTime: "",
    contactDate: "",
    postCode: "",
    serviceType: "",
    jobDescription: "",
  });

  const toggleVisibility = () => {
    setFormVisible(!formVisible);
  };

  const openModalHandler = () => {
    dispatch(openModalAction());
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setFormErrors({ ...formErrors, [name]: "" }); // Clear error when user starts typing
  };

  const validateForm = () => {
    const errors = {};

    if (!formData.fullName.trim()) {
      errors.fullName = "Full Name is required";
    } else if (!/^[a-zA-Z\s]+$/.test(formData.fullName.trim())) {
      errors.fullName = "Full Name must be text only";
    }

    if (!formData.phoneNumber.trim()) {
      errors.phoneNumber = "Phone Number is required";
    } else if (!/^\d+$/.test(formData.phoneNumber.trim())) {
      errors.phoneNumber = "Phone Number must be a valid number";
    }

    if (!formData.contactTime) {
      errors.contactTime = "Contact Time is required";
    }

    if (!formData.contactDate) {
      errors.contactDate = "Contact Date is required";
    }

    if (!formData.postCode.trim()) {
      errors.postCode = "Post Code is required";
    }

    if (!formData.serviceType) {
      errors.serviceType = "Service Type is required";
    }

    if (!formData.jobDescription.trim()) {
      errors.jobDescription = "Job Description is required";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
  
    const {
      fullName,
      phoneNumber,
      contactTime,
      contactDate,
      postCode,
      serviceType,
      jobDescription,
    } = formData;
  
    fetch('http://localhost:3001/send-message', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        fullName,
        phoneNumber,
        contactTime,
        contactDate,
        postCode,
        serviceType,
        jobDescription,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          alert('Message sent successfully!');
        } else {
          alert('Failed to send message.');
        }
        setIsSubmitting(false);
      })
      .catch((error) => {
        console.error('Error:', error);
        alert('An error occurred. Please try again.');
        setIsSubmitting(false);
      });
  
    // Reset the form after submission
    setFormData({
      fullName: "",
      phoneNumber: "",
      contactTime: "",
      contactDate: "",
      postCode: "",
      serviceType: "",
      jobDescription: "",
    });
  
    // Hide the form after submission
    setFormVisible(false);
  };
  

  const today = new Date().toISOString().split("T")[0];

  return (
    <>
      <div className="p-0 m-0 bg-navBg">
        {isModalOpen && <Modal />}
        <div className="bg-background_img pb-16 bg-cover bg-center bg-no-repeat">
          <div className="w-[90%] mx-auto">
            <div className="pt-20 w-full lg:w-[500px] text-white font-Urbanist">
              <h2 id="form" className="text-3xl lg:text-4xl font-bold">
                At PMC, We Have Customer Interest At The Heart Of Our Business
              </h2>
              <p className="py-6 font-medium text-2xl">
                We Have Various Options To Meet Your Needs
              </p>
            </div>
            <div className="flex flex-col lg:flex-row justify-start items-start gap-4 pt-8 pb-1 lg:py-8 text-center font-medium font-Inter cursor-pointer">
              <a href="#form">
                <div
                  className="p-4 rounded-xl bg-white text-[#67757F] hover:text-black hover:bg-gray-200 transition duration-300"
                  onClick={toggleVisibility}
                >
                  Click here for Estimated Quotation
                </div>
              </a>
              <div
                onClick={openModalHandler}
                className="p-3 w-[180px] rounded-xl shadow-lg text-white border-2 border-white hover:bg-white hover:text-black transition duration-300"
              >
                SignUp
              </div>
            </div>
          </div>
        </div>
        <div className="w-[90%] mx-auto pt-1 lg:pt-4 pb-12">
          {formVisible && (
            <div className="w-full mx-auto py-8 shadow-xl bg-white rounded-lg">
              <form className="px-6" onSubmit={handleSubmit}>
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                  <div className="relative gap-2 w-full">
                    <input
                      type="text"
                      name="fullName"
                      value={formData.fullName}
                      onChange={handleInputChange}
                      className={`border w-full peer block appearance-none rounded-lg border-gray-300 bg-white px-2.5 pb-2.5 pt-4 text-sm text-black focus:border-navBg focus:outline-none focus:ring-0 ${
                        formErrors.fullName ? "border-red-500" : ""
                      }`}
                      placeholder=" "
                      required
                    />
                    <label
                      className="absolute bg-white top-2 left-2 z-10 origin-[0] -translate-y-4 scale-75 transform cursor-text select-none px-2 text-sm font-semibold text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-navBg"
                    >
                      Full Name
                    </label>
                    {formErrors.fullName && (
                      <p className="text-red-500 text-xs mt-1">
                        {formErrors.fullName}
                      </p>
                    )}
                  </div>
                  <div className="relative gap-2 w-full">
                    <input
                      type="tel"
                      name="phoneNumber"
                      value={formData.phoneNumber}
                      onChange={handleInputChange}
                      className={`border w-full peer block appearance-none rounded-lg border-gray-300 bg-white px-2.5 pb-2.5 pt-4 text-sm text-black focus:border-navBg focus:outline-none focus:ring-0 ${
                        formErrors.phoneNumber ? "border-red-500" : ""
                      }`}
                      placeholder=" "
                      required
                    />
                    <label
                      className="absolute bg-white top-2 left-2 z-10 origin-[0] -translate-y-4 scale-75 transform cursor-text select-none px-2 text-sm font-semibold text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-navBg"
                    >
                      Phone Number
                    </label>
                    {formErrors.phoneNumber && (
                      <p className="text-red-500 text-xs mt-1">
                        {formErrors.phoneNumber}
                      </p>
                    )}
                  </div>
                  <div className="relative gap-2 w-full">
                    <input
                      type="date"
                      name="contactDate"
                      value={formData.contactDate}
                      onChange={handleInputChange}
                      className={`border w-full peer block appearance-none rounded-lg border-gray-300 bg-white px-2.5 pb-2.5 pt-4 text-sm text-black focus:border-navBg focus:outline-none focus:ring-0 ${
                        formErrors.contactDate ? "border-red-500" : ""
                      }`}
                      placeholder=" "
                      required
                      min={today} // Prevent selecting past dates
                    />
                    <label
                      className="absolute bg-white top-2 left-2 z-10 origin-[0] -translate-y-4 scale-75 transform cursor-text select-none px-2 text-sm font-semibold duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-navBg"
                    >
                      Contact Date
                    </label>
                    {formErrors.contactDate && (
                      <p className="text-red-500 text-xs mt-1">
                        {formErrors.contactDate}
                      </p>
                    )}
                  </div>
                  <div className="relative gap-2 w-full">
                    <input
                      type="time"
                      name="contactTime"
                      value={formData.contactTime}
                      onChange={handleInputChange}
                      className={`border w-full peer block appearance-none rounded-lg border-gray-300 bg-white px-2.5 pb-2.5 pt-4 text-sm text-black focus:border-navBg focus:outline-none focus:ring-0 ${
                        formErrors.contactTime ? "border-red-500" : ""
                      }`}
                      placeholder=" "
                      required
                    />
                    <label
                      className="absolute bg-white top-2 left-2 z-10 origin-[0] -translate-y-4 scale-75 transform cursor-text select-none px-2 text-sm font-semibold duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-navBg"
                    >
                      Contact Time
                    </label>
                    {formErrors.contactTime && (
                      <p className="text-red-500 text-xs mt-1">
                        {formErrors.contactTime}
                      </p>
                    )}
                  </div>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-4">
                  <div className="relative gap-2 w-full">
                    <input
                      type="text"
                      name="postCode"
                      value={formData.postCode}
                      onChange={handleInputChange}
                      className={`border w-full peer block appearance-none rounded-lg border-gray-300 bg-white px-2.5 pb-2.5 pt-4 text-sm text-black focus:border-navBg focus:outline-none focus:ring-0 ${
                        formErrors.postCode ? "border-red-500" : ""
                      }`}
                      placeholder=" "
                      required
                    />
                    <label
                      className="absolute bg-white top-2 left-2 z-10 origin-[0] -translate-y-4 scale-75 transform cursor-text select-none px-2 text-sm font-semibold text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-navBg"
                    >
                      Post Code
                    </label>
                    {formErrors.postCode && (
                      <p className="text-red-500 text-xs mt-1">
                        {formErrors.postCode}
                      </p>
                    )}
                  </div>

                  <div className="relative gap-2 w-full">
                    <select
                      name="serviceType"
                      value={formData.serviceType}
                      onChange={handleInputChange}
                      className={`border w-full peer block appearance-none rounded-lg border-gray-300 bg-white px-2.5 pb-2.5 pt-4 font-semibold text-sm text-gray-500 focus:border-navBg focus:outline-none focus:ring-0 ${
                        formErrors.serviceType ? "border-red-500" : ""
                      }`}
                      required
                    >
                      <option value="">Select Service Type *</option>
                      <option value="Drain Unblocking">Drain Unblocking</option>
                      <option value="Waste Management">Waste Management</option>
                      <option value="Plumbing">Plumbing</option>
                      <option value="Haulage and Removal">
                        Haulage and Removal
                      </option>
                      <option value="Kitchen Installations and Repairs">
                        Kitchen Installations and Repairs
                      </option>
                    </select>
                    {formErrors.serviceType && (
                      <p className="text-red-500 text-xs mt-1">
                        {formErrors.serviceType}
                      </p>
                    )}
                  </div>
                </div>

                <div className="relative gap-2 mt-4 w-full">
                  <textarea
                    name="jobDescription"
                    value={formData.jobDescription}
                    onChange={handleInputChange}
                    placeholder="Describe Job Details"
                    className={`border w-full h-[100px] peer block appearance-none rounded-lg border-gray-300 bg-white px-2.5 pb-2.5 pt-4 text-sm text-black focus:border-navBg focus:outline-none focus:ring-0 ${
                      formErrors.jobDescription ? "border-red-500" : ""
                    }`}
                    required
                  ></textarea>
                  <label
                    className="absolute bg-white top-2 left-2 z-10 origin-[0] -translate-y-4 scale-75 transform cursor-text select-none px-2 text-sm font-semibold text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-navBg"
                  >
                    Job Description
                  </label>
                  {formErrors.jobDescription && (
                    <p className="text-red-500 text-xs mt-1">
                      {formErrors.jobDescription}
                    </p>
                  )}
                </div>

                <div className="w-full lg:w-[50%] mt-4 mx-auto">
                  <button
                    type="submit"
                    className="text-center bg-navBg py-3 text-lg w-full text-white font-semibold font-Inter tracking-wider"
                    disabled={isSubmitting} // Disable button when submitting
                  >
                    {isSubmitting ? (
                      <div className="flex items-center justify-center">
                        <RotatingLines
                          strokeColor="white"
                          strokeWidth="5"
                          animationDuration="0.75"
                          width="24"
                          visible={true}
                        />
                      </div>
                    ) : (
                      "Submit"
                    )}
                  </button>
                </div>
              </form>
            </div>
          )}
        </div>
        <div className="bg-white">
          <AboutHome />
        </div>
        <div className="bg-white">
          <ServiceHome />
        </div>

        <Testimonial />
        <Reason />
      </div>
    </>
  );
};

export default Home;
